// Scope before deriving products, filters or counts.
export function scopeCorporateTenders(tenders, accessibleHotelIds, unrestricted) {
  if (unrestricted) return tenders;
  const allowed = new Set(accessibleHotelIds.map(Number));
  const scopedIds = (ids) => [...new Set((ids || []).map(Number).filter((id) => allowed.has(id)))];
  return tenders.flatMap((tender) => {
    if (!Array.isArray(tender.lines)) {
      const businessUnitIds = scopedIds(tender.business_unit_ids);
      return businessUnitIds.length ? [{ ...tender, business_unit_ids: businessUnitIds,
        can_edit: tender.can_edit !== false && (tender.business_unit_ids || []).every((id) => allowed.has(Number(id))) }] : [];
    }
    const headerIds = scopedIds(tender.business_unit_ids);
    if (!headerIds.length) return [];
    if (!tender.lines.length) return [{ ...tender, tender_ids: [], business_unit_ids: headerIds,
      can_edit: tender.can_edit !== false && (tender.business_unit_ids || []).every((id) => allowed.has(Number(id))) }];
    // A header assignment does not establish access to every product in it.
    const lines = tender.lines.flatMap((line) => {
      const businessUnitIds = scopedIds(line.business_unit_ids).filter((id) => headerIds.includes(id));
      return businessUnitIds.length ? [{ ...line, business_unit_ids: businessUnitIds }] : [];
    });
    if (!lines.length) return [];
    return [{ ...tender, lines, tender_ids: lines.map((line) => line.id),
      business_unit_ids: [...new Set(lines.flatMap((line) => line.business_unit_ids))],
      can_edit: tender.can_edit !== false && lines.length === tender.lines.length &&
        tender.lines.every((line) => (line.business_unit_ids || []).every((id) => allowed.has(Number(id)))) }];
  });
}
